module.exports = new __parcel__URL__("help.aef75b23.png").toString();